

// Constants
import Navigation from './shared/Navigation.vue';
import DashboardSidebar from './shared/Sidebar.vue';
import DashboardNavigation from './shared/dashNavigation.vue';
import Footer from './shared/Footer.vue';


/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component('trustpay-navigation', Navigation);
    Vue.component('dashboard-sidebar', DashboardSidebar);
    Vue.component('dashboard-navigation', DashboardNavigation);
    Vue.component('dashboard-footer', Footer);

    // Vue.component('BannerError', BannerError)
    // Vue.component('BannerSuccess', BannerSuccess)
    // Vue.component('FetchError', FetchError)
    // Vue.component('FieldError', FieldError)
    // Vue.component('NoContentError', NoContentError)
    // Vue.component('LoadingBar', LoadingBar)
    // Vue.component('LoadingButton', LoadingButton)
    // Vue.component('marketCard', marketCard)
    // Vue.component('PlusButton', PlusButton)
    // Vue.component('AuthenticatedField', AuthenticatedField)
    // Vue.component('MemberCard', MemberCard)
    // Vue.component('HideField', HideField)

    
    // Filters
    // Vue.filter('savageMoment', savageMoment)
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/components/globalComp.js